import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Modal, Button } from "react-bootstrap";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
} from "../../../services/master";
import Select from "react-select";
import {
  academylist,
  timetablecreate,
  timetablevalidate,
} from "../../../services/admin";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function AddTimetable() {
  const navigate = useNavigate();
  const [ttype, setTType] = useState("");
  const [ayear, setAYear] = useState("");
  const [ylist, setYList] = useState([]);
  const [sclass, setSClass] = useState("");
  const [clist, setCList] = useState([]);

  const [studiv, setStuDiv] = useState("");
  const [divlist, setDivList] = useState([]);

  const [tlecture, setTLecture] = useState("");
  const [tperiod, setTPeriod] = useState("");

  const [tmon, setTMon] = useState("");
  const [ttue, setTTue] = useState("");
  const [twed, setTWed] = useState("");
  const [tthue, setTThur] = useState("");
  const [tfri, setTFri] = useState("");
  const [tsat, setTSat] = useState("");

  const [errorMsg, setErrorMsg] = useState("");

  const [terrorMsg, setTErrorMsg] = useState("");

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  useEffect(() => {


    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setCList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setDivList(arr);
        }
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listyear(arr[0]);
                setAYear(localStorage.getItem("AYear"));
              }
            }

          }
        }
      });
    } else {
      listyear("");
    }
  }, []);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listyear(e);
    } else {
      setAcaID("");
      listyear("");
    }
  }

  function listyear(aid) {
    setYList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        setYList(res.data);
      }
    });
  }

  function handleClass(e) {
    if (e !== null) {
      setSClass(e);
    } else {
      setSClass("");
    }
  }

  function handleDiv(e) {
    if (e !== null) {
      setStuDiv(e);
    } else {
      setStuDiv("");
    }
  }

  function tvalidate() {
    setTErrorMsg("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setTErrorMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (
      ttype !== "" &&
      ayear !== "" &&
      sclass !== "" &&
      studiv !== "" &&
      tlecture !== "" &&
      valid === ""
    ) {
      const temp1 = new FormData();
      temp1.append("type", ttype);
      temp1.append("year", ayear);
      temp1.append("class", sclass.value);
      temp1.append("section", studiv.value);
      temp1.append("lecture", tlecture);
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp1.append("academy", acaid.value);
      }
      timetablevalidate(temp1).then((response) => {
        if (response.status === false) {
          setTErrorMsg(response.message);
        }
      });
    }
  }

  function submittime(e) {
    e.preventDefault();
    setErrorMsg("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrorMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (terrorMsg === "") {
        if (ttype !== "") {
          if (ayear !== "") {
            if (sclass !== "") {
              if (studiv !== "") {
                if (tlecture !== "") {
                  setLoading(true);
                  const temp = new FormData();
                  temp.append("type", ttype);
                  temp.append("year", ayear);
                  temp.append("class", sclass.value);
                  temp.append("section", studiv.value);
                  temp.append("lecture", tlecture);
                  temp.append("period", tperiod);
                  temp.append("monday", tmon);
                  temp.append("tuesday", ttue);
                  temp.append("wednesday", twed);
                  temp.append("thursday", tthue);
                  temp.append("friday", tfri);
                  temp.append("saturday", tsat);
                  temp.append("sunday", "");
                  temp.append("user_id", localStorage.getItem("UID"));
                  if (localStorage.getItem("Role") === "1" && acaid !== "") {
                    temp.append("academy", acaid.value);
                  }
                  timetablecreate(temp).then((res) => {
                    if (res.status === true) {
                      setLoading(false);
                      navigate("/timetable/alltimetable");
                      toast.success(res.message);
                    } else {
                      setLoading(false);
                      toast.error(res.message);
                    }
                  });
                } else {
                  setErrorMsg("Please Select Lecture");
                }
              } else {
                setErrorMsg("Please Select Section");
              }
            } else {
              setErrorMsg("Please Select Class");
            }
          } else {
            setErrorMsg("Please Select Academic Year");
          }
        } else {
          setErrorMsg("Please Select Timetable Type");
        }
      }
    }

  }
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Add Timetable</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Timetable</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Add Timetable
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <Row>
            <Col xl={12}>
              <Card>
                <Card.Header>
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Select Timetable
                  </h2>
                </Card.Header>
                <Card.Body>
 
  

                  <Row>
                    {localStorage.getItem("Role") === "1" && (
                      <Col xl={4} sm={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Select Academy
                            <span className="text-danger"> *</span>
                          </Form.Label>
                          <Select
                            className="default-select"
                            placeholder="Select Academy"
                            value={acaid}
                            options={alist}
                            onChange={handleAcademy}
                            onBlur={tvalidate}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </Form.Group>
                      </Col>
                    )}

                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          Timetable Type<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={ttype}
                          onChange={(e) => setTType(e.target.value)}
                          onBlur={tvalidate}
                        >
                          <option value="" disabled>
                            Select Timetable Type
                          </option>
                          <option value="Students">Students</option>
                          <option value="Teachers">Teachers</option>
                        </select>
                      </div>
                    </Col>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          Academic Year<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={ayear}
                          onChange={(e) => setAYear(e.target.value)}
                          onBlur={tvalidate}
                        >
                          <option value="" disabled>
                            Select Academic Year
                          </option>
                          {ylist.map((item, i) => {
                            return (
                              <option value={item.id} key={i}>
                                {item.aca_year}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                    <Col xl={4} sm={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Select Class<span className="text-danger"> *</span>
                        </Form.Label>
                        <Select
                          className="default-select"
                          placeholder="Select Class"
                          value={sclass}
                          options={clist}
                          onChange={handleClass}
                          onBlur={tvalidate}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          Section <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Section"
                          value={studiv}
                          options={divlist}
                          onChange={handleDiv}
                          onBlur={tvalidate}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </Col>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          Lecture<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select  form-control wide"
                          value={tlecture}
                          onChange={(e) => setTLecture(e.target.value)}
                          onBlur={tvalidate}
                        >
                          <option value="" disabled>
                            Select Lecture
                          </option>
                          <option value="First Period">First Period</option>
                          <option value="Second Period">Second Period</option>
                          <option value="Third Period">Third Period</option>
                          <option value="Fourth Period">Fourth Period</option>
                          <option value="Fifth Period">Fifth Period</option>
                          <option value="Sixth Period">Sixth Period</option>
                          <option value="Seventh Period">Seventh Period</option>
                          <option value="Eighth Period">Eighth Period</option>
                          <option value="Ninth Period">Ninth Period</option>
                          <option value="Tenth Period">Tenth Period</option>
                          <option value="Break">Break</option>
                          <option value="Lunch">Lunch</option>
                          <option value="Special Class">Special Class</option>
                        </select>
                      </div>
                    </Col>

                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">Time Period</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Time Period"
                          value={tperiod}
                          onChange={(e) => setTPeriod(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">Monday</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Monday"
                          value={tmon}
                          onChange={(e) => setTMon(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">Tuesday</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Tuesday"
                          value={ttue}
                          onChange={(e) => setTTue(e.target.value)}
                        />
                      </div>
                    </Col>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">Wednesday</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Monday"
                          value={twed}
                          onChange={(e) => setTWed(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">Thursday</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Thursday"
                          value={tthue}
                          onChange={(e) => setTThur(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">Friday</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Friday"
                          value={tfri}
                          onChange={(e) => setTFri(e.target.value)}
                        />
                      </div>
                    </Col>

                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">Saturday</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Saturday"
                          value={tsat}
                          onChange={(e) => setTSat(e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>
                  {errorMsg !== "" && (
                    <span className="text-danger">{errorMsg}</span>
                  )}
                  {terrorMsg !== "" && (
                    <span className="text-danger">{terrorMsg}</span>
                  )}
                  <div className="text-end">
                    <a className="btn btn-success" onClick={submittime}>
                      Submit
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>

           

            {/* <Col xl={12}>
            <Card>
              <Card.Header>
                <Form.Label className="main-content-label mb-2">
                  Create Time
                </Form.Label>
              </Card.Header>
              <Card.Body>
                <Table striped bordered hover id="timetable">
                  <thead>
                    <tr>
                      <th>Lecture/Day</th>
                      {days.map((day) => (
                        <th key={day}>{day}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {periods.map((period, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even" : "odd"}
                      >
                        <td
                          className={
                            period.name === "BREAK" ||
                            period.name === "LUNCH BREAK"
                              ? "highlight"
                              : ""
                          }
                        >
                          <div className="period-name">{period.name}</div>
                          <div className="period-time">{period.time}</div>
                        </td>
                        {period.schedule.map((schedule, dayIndex) => (
                          <td
                            key={dayIndex}
                            className={
                              schedule === "BREAK" || schedule === "LUNCH BREAK"
                                ? "highlight"
                                : ""
                            }
                          >
                            <Form.Control
                              type="text"
                              value={schedule}
                              onChange={(event) => {
                                const newPeriods = [...periods];
                                newPeriods[index].schedule[dayIndex] =
                                  event.target.value;
                                // setPeriods(newPeriods); // if using state
                              }}
                            />
                          </td>
                        ))}
                        <td>
                          <a
                            className="btn btn-sm btn-success me-2"
                            title="Save"
                          >
                            <i className="fa fa-save"></i>
                          </a>

                          <a className="btn btn-sm btn-danger" title="Delete">
                            <i className="fa fa-trash"></i>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col> */}
          </Row>
        </div>
      )}
    </div>
  );
}
